//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
(function () {
    'use strict';

    angular
        .module('container.util')
        .factory('operatorClientStatusSharedService', operatorClientStatusSharedService);

    function operatorClientStatusSharedService($rootScope) {
        var service = {};
        var currentStatus = null;
        var currentFlyoutState = null;
        var subscribers = [];

        service.setStatus = function(status) {
            currentStatus = status;
            notifySubscribers();
        };

        service.getStatus = function() {
            return currentStatus;
        };

        service.setFlyoutState = function(flyoutState) {
            currentFlyoutState = flyoutState;
            notifySubscribers();
        };

        service.getFlyoutState = function() {
            return currentFlyoutState;
        };

        service.isOnline = function() {
            return currentStatus === 'online';
        };

        service.subscribe = function(callback) {
            subscribers.push(callback);
            
            return function() {
                var index = subscribers.indexOf(callback);
                if (index > -1) {
                    subscribers.splice(index, 1);
                }
            };
        };

        function notifySubscribers() {
            subscribers.forEach(function(callback) {
                try {
                    callback({
                        status: currentStatus,
                        flyoutState: currentFlyoutState
                    });
                } catch (e) {
                    console.error('Error calling subscriber callback:', e);
                }
            });
        }

        return service;
    }
})();